//menu que se despliega al clickear el avatar del perfil en el navbar
import React from 'react';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Menu, MenuItem } from '@mui/material';
import { PersonOutlineOutlined, ShoppingCartOutlined, ExitToAppOutlined } from '@mui/icons-material';
import { useTranslation } from "react-i18next";

const ProfileMenu = ({ anchorEl, open, handleClose, logoutWithRedirect, closeMenus }) => {
  const [t] = useTranslation("global");

  return (
    <Menu
      id="profile-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "profileDropdown",
      }}
      PaperProps={{
        sx: {
          width: 210,
          padding: 0
        },
      }}
    >
      <MenuItem component={Link} to="/profile" onClick={closeMenus}>
        <PersonOutlineOutlined className="mr-3" />
        {t("navbar.profile")}
      </MenuItem>
      <MenuItem component={Link} to="/mis-compras" onClick={closeMenus}>
        <ShoppingCartOutlined className="mr-3" />
        Mis compras
      </MenuItem>
      <MenuItem onClick={() => { logoutWithRedirect(); closeMenus(); }}>
        <ExitToAppOutlined className="mr-3" />
        Cerrar sesión
      </MenuItem>
    </Menu>
  );
};

export default ProfileMenu;